module.exports = __webpack_public_path__ + "img/Mi muro_Formularios_CCT.265a95f0.svg";